import React, { FC } from "react";

import JobList from "./../../components/Job/JobList";

const JobListPage: FC = () => <JobList />;

export default JobListPage;
